import { FaUsers, FaUserCheck, FaUserTimes, FaDownload } from "react-icons/fa";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import Select from "react-select";
import { generateMonthsFrom2025 } from "../../utilities";
import { CancelRequest } from "../../services/AxiosInstance";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
export function AttendanceHeader({
  selectedMonth,
  setSelectedMonth,
  setParam,
  totalEmployees,
  presentCount,
  absentCount,
  onExport,
  exportLoading,
}) {
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  return (
    <div className="card shadow-sm mb-3">
      <div className="card-body">
        <div className="mb-3 d-flex justify-content-between flex-wrap gap-2">
          <div>
            <h5 className="mb-0 fw-bold">Employee Attendance</h5>
            <p className="text-dark mb-0" style={{ fontSize: "0.9rem" }}>
              Track and manage employee attendance records
            </p>
          </div>
          <button
            className="btn btn-success"
            onClick={onExport}
            disabled={exportLoading}
          >
            {exportLoading ? (
              <Spinner size="sm me-1" animation="border" />
            ) : (
              <FaDownload className="me-1" size={18} />
            )}
            Export
          </button>
        </div>
        <div className="row g-2">
          <div className="col-6 col-md-3">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  right: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(254, 202, 202, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  left: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(254, 202, 202, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #ef4444, #f87171)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h3
                      className="fw-bold mb-1 text-primary"
                      style={{ fontSize: "1.2rem" }}
                    >
                      {totalEmployees}
                    </h3>
                    <p
                      className="mb-0 fw-medium"
                      style={{ fontSize: "0.8rem" }}
                    >
                      Total Employees
                    </p>
                  </div>

                  <span
                    className="d-none rounded-3 d-sm-flex justify-content-center align-items-center"
                    style={{
                      padding: "0.7rem",
                      background: "linear-gradient(135deg, #ef4444, #f87171)",
                      boxShadow: "0 6px 15px rgba(239, 68, 68, 0.3)",
                    }}
                  >
                    <FaUsers size={20} className="text-white" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-3">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(187, 247, 208, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(187, 247, 208, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #16a34a, #22c55e)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h3
                      className="mb-1 fw-bold"
                      style={{ fontSize: "1.2rem", color: "#14532d" }}
                    >
                      {presentCount}
                    </h3>
                    <p
                      className="fw-medium mb-0"
                      style={{ fontSize: "0.8rem" }}
                    >
                      Present Employee
                    </p>
                  </div>
                  <div
                    className="d-none rounded-3 d-sm-flex justify-content-center align-items-center"
                    style={{
                      padding: "0.7rem",
                      background: "linear-gradient(135deg, #16a34a, #22c55e)",
                      boxShadow: "0 4px 10px rgba(22, 163, 74, 0.3)",
                    }}
                  >
                    <FaUserCheck size={20} className="text-white" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-3">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(234, 179, 8, 0.15), rgba(254, 243, 199, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(234, 179, 8, 0.12), rgba(254, 243, 199, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #eab308, #facc15)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h3
                      className="mb-1"
                      style={{ fontSize: "1.2rem", color: "#713f12" }}
                    >
                      {absentCount}
                    </h3>
                    <p
                      className="mb-0 fw-medium"
                      style={{ fontSize: "0.8rem" }}
                    >
                      Absent Employee
                    </p>
                  </div>
                  <span
                    className="d-none rounded-3 d-sm-flex justify-content-center align-items-center"
                    style={{
                      padding: "0.7rem",
                      background: "linear-gradient(135deg, #eab308, #facc15)",
                      boxShadow: "0 4px 10px rgba(234, 179, 8, 0.3)",
                    }}
                  >
                    <FaUserTimes size={20} className="text-white" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div>
              <DebounceSmallSearchInput
                handleSearchChange={handleSearchChange}
              />
            </div>
            <div className=" mt-2">
              <Select
                placeholder="Select Month"
                classNamePrefix="select"
                className="react-select"
                options={generateMonthsFrom2025()}
                value={
                  generateMonthsFrom2025()?.filter(
                    (item) => item?.value == selectedMonth
                  ) || null
                }
                onChange={(selected) => setSelectedMonth(selected?.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
